/* Luxe layer: scroll reveal, progress bar, back-to-top. Purely visual; no Shopify logic touched. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    // Progress bar + back-to-top
    var bar = document.createElement('div');
    bar.id = 'scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var top = document.createElement('button');
    top.id = 'back-to-top';
    top.type = 'button';
    top.setAttribute('aria-label', 'Back to top');
    top.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(top);

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var p = h > 0 ? window.scrollY / h : 0;
        bar.style.transform = 'scaleX(' + Math.min(1, p) + ')';
        top.classList.toggle('is-visible', window.scrollY > 700);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Scroll reveal
    var targets = [];
    document.querySelectorAll('main section, #MainContent > section, .shopify-section section').forEach(function (s) {
      if (s.closest('.hero-section') || s.classList.contains('hero-section')) return;
      s.classList.add('reveal');
      targets.push(s);
    });
    document.querySelectorAll('.grid').forEach(function (g) {
      if (g.querySelector('.product-card') || g.children.length > 1) {
        g.classList.add('reveal-stagger');
        targets.push(g);
      }
    });

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) { io.observe(t); });

    // Safety net: dynamically injected product cards (JS filters) never stay hidden
    setTimeout(function () {
      targets.forEach(function (t) {
        var r = t.getBoundingClientRect();
        if (r.top < window.innerHeight) t.classList.add('is-visible');
      });
    }, 1200);

    // Click to copy promo codes
    document.addEventListener('click', function (e) {
      var copyBtn = e.target.closest('[data-copy-code]');
      if (!copyBtn) return;
      var code = copyBtn.getAttribute('data-copy-code');
      if (!code) return;

      var prevText = copyBtn.innerHTML;
      function showCopied() {
        var copyLabel = copyBtn.querySelector('.promo-card__code-copy, em');
        if (copyLabel) {
          var orig = copyLabel.textContent;
          copyLabel.textContent = 'Copied!';
          setTimeout(function () { copyLabel.textContent = orig; }, 2000);
        }
        var tc = document.getElementById('toast-container');
        if (tc) {
          var t = document.createElement('div');
          t.className = 'toast-msg';
          t.textContent = 'Discount code ' + code + ' copied!';
          tc.appendChild(t);
          setTimeout(function () { t.remove(); }, 3000);
        }
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function () {});
      } else {
        var input = document.createElement('input');
        input.value = code;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        showCopied();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
